import React from 'react'
import View from 'components/View'
import trimStringUtil from 'utils/string/trim'
import removeNbspStringUtil from 'utils/string/remove-nbsp'
import Accordion from 'components/Accordion'
import H4 from 'components/H4'

const INGREDIENTS_LABEL = 'Ingredients'

export default function QuickShopProductSidebarIngredients ({ ingredients }) {
  return (
    <Accordion
      label={(
        <View className='quick-shop-product-sidebar-accordion-label-wrapper'>
          <H4 className='quick-shop-product-sidebar-accordion-label'>{INGREDIENTS_LABEL}</H4>
        </View>
      )}
    >
      <View className='quick-shop-product-sidebar-short-ingredients'>
        <div dangerouslySetInnerHTML={{ __html: trimStringUtil(removeNbspStringUtil(ingredients)) }} />
      </View>
    </Accordion>
  )
}
